
import { Options, Vue } from "vue-class-component";

export default class UiTableFooterItemComponent extends Vue {}
